import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { CheckBox } from 'react-native-elements'
import { useState } from 'react'
import { mapSelectValue } from '../../../utils'

const MainformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postMaOnline } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const intialValues = {
        personalExemptions: null,
        spouseExemption: null,
        dependents: '',
        additionalExemptions: "",
        additionalWithholding: "",
        martialstatus: "",
        claimNoExemptions: ""

    }

    const paschema = yup.object({
        personalExemptions: yup
            .string()
            .required('Personal Exemption is  a required field'),
        spouseExemption: yup.string().nullable(),
        dependents: yup.string().nullable(),
        additionalExemptions: yup.mixed().nullable(),
        additionalWithholding: yup.string().nullable(),
        martialstatus: yup.string().required("Martial status is a required field"),
        claimNoExemptions: yup
            .string()
            .nullable()
            .oneOf(["0", ""], "Only 0 or empty is allowed")

    })

    const checkboxData = [
        { id: 1, title: 'Check if you will file as head of household on your tax return', isChecked: false },
        { id: 2, title: 'Check if you are blind', isChecked: false },
        { id: 3, title: 'Check if spouse is blind and not subject to withholding', isChecked: false },
        { id: 4, title: 'Check if you are a full-time student engaged in seasonal, part-time or temporary employment whose estimated annual income will not exceed $8,000', isChecked: false },
    ];


    const [checkboxes, setCheckboxes] = useState(checkboxData);

    const toggleCheckbox = (id: any) => {
        const newCheckboxes = checkboxes.map(checkbox =>
            checkbox.id === id ? { ...checkbox, isChecked: !checkbox.isChecked } : checkbox
        );
        setCheckboxes(newCheckboxes);
    };

    const getCheckedIds = () => {
        return checkboxes
            .filter(checkbox => checkbox.isChecked)
            .map(checkbox => checkbox.id.toString());
    };
    const options3 = [
        { key: 1, value: 'I am under 65' },
        { key: 2, value: 'I am currently 65 or older or will turn 65 before next year' },

    ]
    const options2 = [
        { key: 4, value: 'Spouse under 65 or exemption allowed' },
        { key: 5, value: 'Spouse 65 or older before next year' }
    ]
    const options1 = [
        { key: 1, value: 'Single' },
        { key: 2, value: 'Married' },
        { key: 3, value: 'Married but withhold as single' }
    ]
    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MA Witholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={paschema}
                    onSubmit={async (values, actions) => {

                        const total = values?.personalExemptions + values?.spouseExemption + Number(values?.dependents)
                        const data = {
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            essObKey: essUserOnBoardingKey,
                            completeOnline: mode === 'upload' ? false : true,
                            essUserKey: initializestore.initializeData.userkey,
                            entityId: personalstore.personalData?.entityId,
                            personalExemptions: values?.personalExemptions,
                            spouseExemptions: values?.spouseExemption,
                            noofDependents: values?.dependents ? values?.dependents : null,
                            additionalWithholdings: values?.additionalWithholding ? values?.additionalWithholding : null,
                            totalNoofExemptions: total,
                            additionalExemptions: getCheckedIds(),
                            maritalStatus: values?.martialstatus,
                            claimExemptions: values?.claimNoExemptions

                        }

                        const response = await postMaOnline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                const ids = getCheckedIds()
                                navigation.navigate('maonline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                    ids,
                                    total
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }

                    }}
                >
                    {(props) => (
                        <>
                            <Card>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Martial Status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: "hidden" }}>
                                        <SelectKeyValue
                                            title="Martial Status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.martialstatus
                                            )}
                                            onSelect={(option: any) => {
                                                if (option == 1 || option == 3) {
                                                    props.setFieldValue('martialstatus', "S")

                                                }
                                                else {
                                                    props.setFieldValue('martialstatus', "M")

                                                }
                                            }}
                                            textColor="primary"
                                        />{props.touched.martialstatus && props.errors.martialstatus && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.martialstatus}
                                            </Text>
                                        )}

                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Select Your Personal Exemption *'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title={
                                                'Select Your Personal Exemption'
                                            }
                                            options={options3}
                                            selectedOption={mapSelectValue(
                                                options3,
                                                props.values.personalExemptions
                                            )}
                                            onSelect={(option: any) => {

                                                props.setFieldValue('personalExemptions', option)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.personalExemptions &&
                                            props.errors.personalExemptions && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.personalExemptions as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Select Your Spouse Exemption'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title={
                                                'Select Your Spouse Exemption'
                                            }
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.spouseExemption
                                            )}
                                            onSelect={(option: any) => {

                                                props.setFieldValue('spouseExemption', option)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.spouseExemption &&
                                            props.errors.spouseExemption && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.spouseExemption as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter no of qualified dependents '}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.dependents}
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('dependents')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.dependents &&
                                            props.errors.dependents && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.dependents}
                                                </Text>
                                            )}
                                    </View>
                                </View>




                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'To claim no exemptions, enter 0 '}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.claimNoExemptions}
                                            onChangeText={(text) => {

                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('claimNoExemptions')(text)
                                                }

                                            }}
                                        />
                                        {props.touched.claimNoExemptions &&
                                            props.errors.claimNoExemptions && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.claimNoExemptions}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                ' Select any of the following'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ flexDirection: "row", flexWrap: "wrap", overflow: 'hidden' }}>
                                        {checkboxes.map(checkbox => (
                                            <CheckBox
                                                key={checkbox.id}
                                                title={checkbox.title}
                                                checked={checkbox.isChecked}
                                                onPress={() => {
                                                    toggleCheckbox(checkbox.id)
                                                    const updatedCheckboxes = checkboxes.map(c =>
                                                        c.id === checkbox.id ? { ...c, isChecked: !c.isChecked } : c
                                                    )
                                                    const newCheckedIds = updatedCheckboxes
                                                        .filter(c => c.isChecked)
                                                        .map(c => c.id.toString())
                                                    props.setFieldValue("additionalExemptions", newCheckedIds)
                                                    if (newCheckedIds.includes("4")) {
                                                        props.setFieldValue("additionalWithholding", "")
                                                    }
                                                }}
                                                checkedColor="#0B495C"
                                                uncheckedColor="#0B495C"
                                                containerStyle={{ backgroundColor: 'transparent', borderWidth: 0, flexShrink: 1 }}
                                                titleProps={{
                                                    style: {
                                                        fontWeight: "normal",
                                                        color: "#0B495C",

                                                    }
                                                }}
                                            />
                                        ))}
                                    </View>
                                    {props.touched.additionalExemptions &&
                                        props.errors.additionalExemptions && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.additionalExemptions as string}
                                            </Text>
                                        )}
                                </View>

                                {!(props.values.additionalExemptions && props.values.additionalExemptions.includes("4")) && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Additional withholding per pay period under agreement with employer $ '}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.additionalWithholding}
                                                onChangeText={(text) => {

                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('additionalWithholding')(text)
                                                    }

                                                }}
                                            />
                                            {props.touched.additionalWithholding &&
                                                props.errors.additionalWithholding && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.additionalWithholding}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                )}


                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default MainformationForm
